
import EDIconButton from '../../Buttons/IconButton/EDIconButton';
import { CommonPropsAndTypes } from '../../_Types/StandardComponentProps';
import { TextEditEndAdornment } from '../../TextEdit/EDTextEdit';
import { useIsSmallScreen } from '../../../Hooks/useFullscreenView';

interface IProps {
  onClick?: () => void;
  disabled?: boolean;
  tooltip?: string;
  adornmentPadding?: CommonPropsAndTypes.ExpandedSpacingType;
}
export const TimePickerInputAdornment: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const isSmall = useIsSmallScreen();
  return (
    <TextEditEndAdornment>
      <EDIconButton
        style={{ display: isSmall ? 'block' : 'none' }}
        disabled={props.disabled}
        iconColor="action"
        iconSize="medium"
        disableTabbing={true}
        margin="none"
        icon="access_time"
        tooltip={'Välj ' + (props.tooltip ?? 'Time')}
        padding={props.adornmentPadding ?? 'dense'}
        onClick={props.onClick}
      />
    </TextEditEndAdornment>
  );
};
